export default {
  description: "",
  email: "",
  name: "",
  telephone: "",
};
